import { FormControl, MenuItem, Select, useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import React, { FC } from 'react';

interface ISortingProps {
  switchActive?: any;
  change?: any;
  icon?: any;
  select?: any;
  sorts?: any[];
  page?: string | number | symbol | any;
}

export const Sorting: FC<ISortingProps> = ({ switchActive, change, icon, select, sorts, page }) => {
  //Максимальная ширина экрана. Возвращает - true
  const mobileScreen = useMediaQuery('(max-width:900px)');
  return (
    <div
      className={classNames('sorting', switchActive, {
        mobile: mobileScreen,
        [page]: page,
      })}
    >
      <FormControl
        sx={{
          m: 1,
          minWidth: 120,
          fontStyle: 'normal',
        }}
      >
        <Select value={select} onChange={change} displayEmpty IconComponent={icon}>
          {sorts &&
            sorts.map(({ sort, text }) => {
              return (
                <MenuItem key={`${sort}_${text}`} value={sort}>
                  {text}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </div>
  );
};
